import { useQuery } from "@tanstack/react-query";
import { PROJECTS } from "@/data/mock";
import { withLatency } from "./simulate";

export async function fetchProjects() {
  return withLatency(PROJECTS);
}

export function useProjects() {
  return useQuery({ queryKey: ["projects"], queryFn: fetchProjects, staleTime: 60_000 });
}
